import type { IconName } from '~/components/Icon';

export interface Platform {
  id: string;
  icon: IconName;
  titleKey: string;
}

export const PLATFORMS: Platform[] = [
  {
    id: 'instagram',
    icon: 'instagram',
    titleKey: 'instagram',
  },
  {
    id: 'tiktok',
    icon: 'tiktok',
    titleKey: 'tiktok',
  },
  {
    id: 'spotify',
    icon: 'spotify',
    titleKey: 'spotify',
  },
  {
    id: 'apple-music',
    icon: 'apple',
    titleKey: 'appleMusic',
  },
  {
    id: 'youtube',
    icon: 'youtube',
    titleKey: 'youtube',
  },
  {
    id: 'facebook',
    icon: 'facebook',
    titleKey: 'facebook',
  },
];
